import React, { useState } from 'react';
import { MdEdit } from 'react-icons/md';
import { HeadingWithCreateBtn, Search, Table } from 'src/components';
import DashboardLayout from 'src/containers/dashboard-layout';
import useFetch from 'src/hooks/useFetch';
import AddCategory from './crud/AddModifiers';
import CrudIcon from 'src/components/crud-icon';
import { AiOutlinePlus } from 'react-icons/ai';
import Button from 'src/components/button';
interface IProps {}

const Category: React.FC<IProps> = ({}) => {
  const [showModal, setShowModal] = React.useState(true);
  const [query, setQuery] = React.useState<string>('');
  const [editModifier, setEditModifier] = useState(false);
  const [editModifierId, setEditModifierId] = useState('');
  const [editModifierData, setEditModifierData] = useState([]);

  const {
    data: modifiersData,
    fetchData,
    isLoading,
    errorText,
  } = useFetch('/modifiers');

  const handleModal = () => setShowModal(!showModal);

  const handlEditModifier = (data: any) => {
    setEditModifier(true);
    setEditModifierData(data);
    setEditModifierId(data.id);
    setShowModal(false);
    setTimeout(() => {
      setShowModal(true);
    }, 100);
  };
  const handleButtonClick = () => {
    setShowModal(false);
    setEditModifier(false);

    setTimeout(() => {
      setShowModal(true);
    }, 100);
    setEditModifier(false);
  };

  const searchCategoryData = modifiersData?.modifiers?.filter((item: any) => {
    if (query === '') {
      return item;
    } else if (item?.name?.toLowerCase().includes(query.toLowerCase())) {
      return item;
    }
  });

  const tableColumn = [
    {
      Header: 'Modifiers Name',
      accessor: 'name',
    },
    {
      Header: 'Number Of Options',
      accessor: 'numberOfOptions',
    },
    {
      Header: 'Action',

      Cell: (row: any) => (
        <CrudIcon
          data={row?.cell?.row?.original}
          url="/modifiers/remove"
          fetchData={fetchData}
        >
          <div
            className="w-7 h-7 rounded-xl bg-light-grey bg-opacity-50 flex items-center justify-center"
            onClick={() => handlEditModifier(row?.cell?.row?.original)}
          >
            <MdEdit color="#4062FF" />
          </div>
        </CrudIcon>
      ),
    },
  ];
  return (
    <>
      <div className="grid-cols-12 gap-4 grid">
        <div className="col-span-12 ">
          {' '}
          //md:col-span-8
          {/* <HeadingWithCreateBtn
            icon={<AiOutlinePlus size={20} />}
            btnTxt="create modifiers"
            title="Modifiers"
            onClick={handleButtonClick}
          />
          <Search
            placeholder="Search Modifier ....."
            query={query}
            setQuery={setQuery}
          />
 */}
          <div className="flex items-center justify-between ">
            <Search
              placeholder="search modifier"
              query={query}
              setQuery={setQuery}
            />
            <Button
              text={'Add modifier'}
              variant="primary"
              onClick={handleButtonClick}
              icon={<AiOutlinePlus size={20} />}
            />
          </div>
          <Table
            loading={isLoading}
            tableColumn={tableColumn}
            tableData={searchCategoryData}
            pagination={true}
          />
        </div>
      </div>
      <AddCategory
        editModifierData={editModifierData}
        handleModal={handleModal}
        showModal={showModal}
        fetchData={fetchData}
        editModifier={editModifier}
        editModifierId={editModifierId}
        setEditModifier={setEditModifier}
        setEditModifierId={setEditModifierId}
      />
    </>
  );
};

export default React.memo(Category);
